"use client"

import { UserSearch } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UserSearchIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UserSearchIcon = component(Icon)({ as: UserSearch })
